import { Component, OnInit } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-ficha-pago-oxxo',
  templateUrl: './ficha-pago-oxxo.component.html',
  styleUrls: ['./ficha-pago-oxxo.component.scss']
})
export class FichaPagoOxxoComponent implements OnInit {
  ficha: any = null;
  cargando = true;
  error = '';

  constructor(
    private http: HttpClient,
    private route: ActivatedRoute,
    private router: Router
  ) {}

  ngOnInit(): void {
    const chargeId = this.route.snapshot.paramMap.get('id');
    if (!chargeId) {
      this.cargando = false;
      this.error = 'No encontramos la ficha solicitada.';
      return;
    }
    const headers = new HttpHeaders({
      Accept: 'application/json',
      Authorization: localStorage.getItem('token') || ''
    });
    const url = environment.BASE_URL + '/api/pago/openpay/ficha-efectivo/?id=' + encodeURIComponent(chargeId);
    this.http.get<any>(url, {headers}).subscribe(
      response => {
        this.ficha = response;
        this.cargando = false;
      },
      response => {
        this.cargando = false;
        this.error = response.error && response.error.error ? response.error.error : 'No fue posible cargar la ficha de pago.';
      }
    );
  }

  imprimir(): void {
    window.print();
  }

  volver(): void {
    this.router.navigate([this.paymentRoutePrefix() + '/realizar-pago']);
  }

  private paymentRoutePrefix(): string {
    return this.router.url.indexOf('/cliente/') === 0 ? '/cliente' : '/perfil';
  }
}
